import { useMemo } from "react";

import { detectDevicePlatform, type DevicePlatform, type MapApp } from "./providers";

export function getPreferredDirectionOrder(
  userPreferred: MapApp | "auto" = "auto",
  platform: DevicePlatform = detectDevicePlatform(),
): MapApp[] {
  if (userPreferred !== "auto") {
    const rest = (["google", "apple", "waze"] as MapApp[]).filter((provider) => provider !== userPreferred);
    return [userPreferred, ...rest];
  }

  if (platform === "ios" || platform === "macos") {
    return ["apple", "google", "waze"];
  }

  if (platform === "android" || platform === "windows" || platform === "linux" || platform === "unknown") {
    return ["google", "waze", "apple"];
  }

  return ["google", "apple", "waze"];
}

export function usePreferredDirectionOrder(userPreferred: MapApp | "auto" = "auto") {
  return useMemo(() => getPreferredDirectionOrder(userPreferred), [userPreferred]);
}
